import {isObject, isNil, find} from "lodash";

export default {
  computed: {
    selectOptions () {
      return this.schema.selectOptions || {};
    },
  },
  methods: {
    formatValueToField(value) {
      if(isNil(value)) {
        return null;
      }
      return value;
    },
    getItemValue(item) {
      if (isObject(item)){
        if (typeof this.schema["selectOptions"] !== "undefined" && typeof this.schema["selectOptions"]["value"] !== "undefined") {
          return item[this.schema.selectOptions.value];
        } else {
          // Use 'id' instead of 'value' cause of backward compatibility
          if (typeof item["id"] !== "undefined") {
            return item.id;
          } else {
            throw "`id` is not defined. If you want to use another key name, add a `value` property under `selectOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/select.html#select-field-with-object-items";
          }
        }
      } else {
        return item;
      }
    },
    getItemName(item) {
      if (isObject(item)){
        if (typeof this.schema["selectOptions"] !== "undefined" && typeof this.schema["selectOptions"]["name"] !== "undefined") {
          return item[this.schema.selectOptions.name];
        } else {
          if (typeof item["name"] !== "undefined") {
            return item.name;
          } else {
            throw "`name` is not defined. If you want to use another key name, add a `name` property under `selectOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/select.html#select-field-with-object-items";
          }
        }
      } else {
        return item;
      }
    },
  }
}


// WEBPACK FOOTER //
// ./src/helpers/mixins/form/protoselect.js